import React, { useEffect } from 'react';
import { Draggable } from 'gsap/Draggable';
import { gsap } from 'gsap';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import './style.css';
import {imageArray} from '../../helpers/galleryImg';

gsap.registerPlugin(Draggable);

const GallerySlider = () => {

  useEffect(() => {
    if (window.matchMedia('(min-width: 992px)').matches) { 
      Draggable.create('.gallery__images', {
        bounds: '.wrapper',
        inertia: true
      });
    }

    document.querySelectorAll('.gallery__item').forEach(function(e) {
      let img = new Image(), hrefURL = e.getAttribute('href');
      img.onload = function() {
        e.dataset.pswpWidth = this.width;
        e.dataset.pswpHeight = this.height;
      };
      img.src = hrefURL;
    });

    const lightbox = new PhotoSwipeLightbox({
      gallery: '.gallery__images',
      children: '.gallery__item',
      pswpModule: PhotoSwipe,
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
    };
  }, []);

  return ( 
    <div className='wrapper'>
      <h2 className="title__gallery title-2" id='title__gallery'>Nature<span className='accent'>Loading...</span></h2>

      <div className='gallery__images'>
        {imageArray.map((image, index) => (
          <a
            key={index}
            href={image.src}
            data-pswp-width={image.width}
            data-pswp-height={image.height}
            className="gallery__item"
          >
            <img src={image.src} alt={image.alt} loading="lazy" />
          </a>
        ))}
      </div>

    </div>
  );
};

export default GallerySlider;
